export default {
  getPermissions (state) {
    state.all_permission.forEach(permission => {
      permission.children.forEach(element => {
        state.permissions.forEach(per => {
          if (element.id === per.id) {
            element.select = true
          }
        })
      })
    })
    return state.all_permission
  },

  getSelectPermission (state) {
    var selects = []
    state.all_permission.forEach(permission => {
      permission.children.forEach(element => {
        if (element.select) {
          selects.push(element.id)
        }
      })
    })
    return selects
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-permission/getters.js